module.exports = __webpack_public_path__ + "static/media/cc30caa4.jpg";